import { createReducer, on } from '@ngrx/store';

import { IAllSelectedItemsData, ISelectData } from '@shared/types';

import { clear_selected_data, update_selected_data } from '../actions/select.action';

const initialState: ISelectData = {};
export const selectReducer = createReducer(
    initialState,
    on(update_selected_data, (state, { selectData }): ISelectData => {
        const { allSelectedItems, ...selectedValues } = selectData;
        const nextAllSelectedItems: IAllSelectedItemsData | undefined = Object.prototype.hasOwnProperty.call(
            selectData,
            'allSelectedItems',
        )
            ? {
                  ...(state.allSelectedItems || {}),
                  ...(allSelectedItems || {}),
              }
            : undefined;

        return {
            ...state,
            ...selectedValues,
            ...(nextAllSelectedItems ? { allSelectedItems: nextAllSelectedItems } : {}),
        };
    }),
    on(clear_selected_data, (_state): ISelectData => ({})),
);
